import { getResponsiveSearchAdMobilePlacementStyles } from '../../styles';

export const getAppAdsBasePlacementStyles = () => ({
  placementCard: {
    width: 300,
    height: 600,
    border: '10px solid rgba(214, 214, 214, 1)',
    borderTopRightRadius: '30px',
    borderTopLeftRadius: '30px',
    borderBottom: 'none',
  },
  placementPreview: {
    display: 'flex',
    justifyContent: 'center',
  },
  phoneInnerContent: {
    marginTop: 30,
    marginBottom: 30,
    height: '90%',
    marginLeft: 10,
    marginRight: 10,
    borderRadius: 10,
  },
  videoPlayerRoot: {
    height: '100%',
    width: '100%',
    backgroundColor: 'black',
    borderRadius: 10,
  },
});

export const getAppAdsMobileStyles = () => {
  const {
    placementCard,
    placementTextContainer,
    placementContentContainer,
    ...rest
  } = getResponsiveSearchAdMobilePlacementStyles();
  const { placementCard: appAdsPlacementCard, ...appAdsStyles } = getAppAdsBasePlacementStyles();

  return {
    ...rest,
    ...appAdsStyles,
    placementCard: {
      ...placementCard,
      ...appAdsPlacementCard,
      width: '400px',
      height: '300px',
    },
    placementTextContainer: {
      ...placementTextContainer,
      flex: '1',
    },
    placementContentContainer: {
      ...placementContentContainer,
      marginTop: 10,
      boxShadow: '0px 0.511px 1.533px rgb(0 0 0 / 10%), 0px 2.72533px 6.132px rgb(0 0 0 / 13%)',
      borderRadius: '5.11px',
      border: '0.5px solid #ddd',
      background: '#fff',
      '&.placement-card-content': {
        height: 'auto',
        padding: '10px',
      },
    },
  };
};

export const getAppAdsM365MobileStyles = () => {
  const { placementCard: appAdsPlacementCard, ...appAdsStyles } = getAppAdsBasePlacementStyles();

  return {
    ...appAdsStyles,
    placementCard: {
      ...appAdsPlacementCard,
      display: 'flex',
      width: '300px',
      height: '300px',
      '& .placement-card-content': {
        height: '130px',
        padding: '10px',
        boxShadow: '0px 0.511px 1.533px rgb(0 0 0 / 10%), 0px 2.72533px 6.132px rgb(0 0 0 / 13%)',
        marginTop: 30,
        border: '0.5px solid #ddd',
        background: '#fff',
        width: '100%',
      },
    },
    preview: {
      display: 'flex',
      justifyContent: 'center',
    },
    previewContent: {
      border: '1px solid #C8C8C8',
      boxShadow: 'none',
      width: 340,
      height: 80,
      padding: '5px 10px 5px 15px',
      marginTop: 150,
    },
    placementBusinessNameWithAdsLabel: {
      display: 'block',
      color: 'black',
      textDecoration: 'none',
      fontSize: '20px !important',
      maxWidth: 300,
      verticalAlign: 'middle',
      lineHeight: '30px',
      marginTop: 0,
      '& .ads-label': {
        backgroundColor: 'blue !important',
        borderRadius: 4,
        height: 15,
        verticalAlign: 'middle',
        padding: '0 4px !important',
        width: 'auto',
        display: 'inline-block',
        position: 'static',
        margin: '0 4px 0 0',
        fontSize: 10,
        color: 'white !important',
        lineHeight: '15px',
      },
      '& .business-name': {
        fontSize: '20px !important',
      },
    },
    placementShortHeadline: {
      display: 'block',
      fontSize: 13,
      marginTop: 2,
      lineHeight: '19.5px',
    },
    placementDescription: {
      display: 'block',
      color: 'black',
      textDecoration: 'none',
      fontSize: 13,
      marginTop: 2,
      lineHeight: '19.5px',
    },
    description: {
      display: 'inline-block',
    },
  };
};

export const getAppAdsMSNMobileStyles = () => {
  const { placementCard: appAdsPlacementCard, ...appAdsStyles } = getAppAdsBasePlacementStyles();

  return {
    ...appAdsStyles,
    placementCard: {
      ...appAdsPlacementCard,
      height: '300px',
      width: '400px',
    },
    msnDescription: {
      paddingTop: '5px',
      fontWeight: '600',
      fontSize: '14px',
    },
    msnPlacementImage: {
      '& .cropped-image-view': {
        borderRadius: '5px',
      },
    },
  };
};

export const getAppAdsCasualGamesStyles = () => {
  const { placementCard: appAdsPlacementCard, ...appAdsStyles } = getAppAdsBasePlacementStyles();

  return {
    ...appAdsStyles,
    placementCard: {
      ...appAdsPlacementCard,
      height: '350px',
      width: '300px',
    },
    casualGamesBase: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
};
